import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: 'Borrow {currencySymbol}',

  firstColumnTitle: 'You borrowed',
  secondColumnTitle: 'Total collateral',
  thirdColumnTitle: 'Loan to value',
  graphDotStable: 'Stable',
  graphDotVariable: 'Variable',
});
